export function ButtonPrimary({
  onClick,
  children,
  icon,
  disabled,
  type = 'button',
}) {
  return (
    <button
      className="flex-col justify-center items-center inline-flex"
      type={type}
      onClick={onClick}
      disabled={disabled}
    >
      <div
        className={`self-stretch mh-44px !py-3 ${disabled ? 'bg-slate-200' : 'bg-teal-800'} rounded-lg justify-center items-center inline-flex ${
          icon ? '!pl-6 !pr-4' : '!px-8'
        }`}
      >
        <div
          className={`!text-center text-white !text-sm font-bold font-['Raleway'] ${
            icon ? 'mr-2' : ''
          }`}
        >
          {children}
        </div>
        {icon}
      </div>
    </button>
  );
}

export function ButtonOutline({
  onClick,
  disabled,
  children,
  type = 'button',
}) {
  return (
    <button
      className="flex-col justify-center items-center inline-flex"
      type={type}
      onClick={onClick}
      disabled={disabled}
    >
      <div className="self-stretch !px-8 !py-3 rounded-lg justify-center items-center inline-flex">
        <div className="!text-center text-teal-800 !text-sm font-bold font-['Raleway']">
          {children}
        </div>
      </div>
    </button>
  );
}
